import React from "react";
import { useSelector } from "react-redux";
import dummmyImg from "../../../images/profile/images1.png";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { selectConversationNull } from "../../../store/actions/SessionActions";

function MessageHeader({ userId, handleExportPDF }) {
  const dispatch = useDispatch();
  const selectedConversation = useSelector(
    (state) => state.session.selectedConversationDetails
  );

  function capitalizeFirstLetterOfFirstWord(phrase) {
    if (phrase?.length === 0) return phrase;
    return phrase?.charAt(0).toUpperCase() + phrase?.slice(1);
  }

  const handleOpenInNewTab = () => {
    const url = `/user-details?data=${selectedConversation.otherPersonId}`;
    window.open(url, "_blank");
  };

  return (
    <div className="message-header shadow-md">
      {selectedConversation && (
        <div className="d-flex align-items-center pointer justify-content-between w-100">
          <div
            className="d-flex align-items-center pointer"
            onClick={handleOpenInNewTab}
          >
            <span
              className="back-button"
              style={{ marginRight: "1rem" }}
              onClick={(e) => {
                e.stopPropagation();
                dispatch(selectConversationNull(null));
              }}
            >
              Back
            </span>
            <img
              src={
                selectedConversation.otherPersonImage?.url
                  ? "" +
                    selectedConversation.otherPersonImage?.url
                  : dummmyImg
              }
              alt=""
              className="message-header_image"
            />
            <div
              className="d-flex align-items-start flex-column"
              style={{ marginLeft: "1rem" }}
            >
              <span className="header_name">
                {capitalizeFirstLetterOfFirstWord(
                  selectedConversation?.otherPersonName
                )}
              </span>
              {/* <span className='header_state'>typing...</span> */}
            </div>
          </div>
          <div className="">
            <button
              onClick={handleExportPDF}
              className="btn btn-primary"
              style={{
                backgroundColor: "#a6f9fe",
                borderColor: "#a6f9fe",
                color: "#000",
                padding: "8px 8px",
                borderRadius: "5px",
                fontSize: "10px",
                cursor: "pointer",
                transition: "all 0.3s ease",
                "&:hover": {
                  backgroundColor: "#8cebf1",
                  borderColor: "#8cebf1",
                  color: "#fff",
                },
              }}
            >
              Export Chat
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default MessageHeader;
